import { GoToPortalButton } from "@/components/Layout/GoToPortalButton/GoToPortalButton";
import { Header } from "@/components/Layout/Header/Header";
import { LogoutButton } from "@/components/Layout/LogoutButton/LogoutButton";
import { useIsAnonymousUser } from "@/hooks/useIsAnonymousUser";

/**
 * OnboardingHeader component
 *
 * Displays appropriate navigation button in the header based on authentication status:
 * - For anonymous customers: Shows portal navigation button
 * - For authenticated customers: Shows logout button
 */
export const OnboardingHeader = () => {
  const [isAnonymousUser] = useIsAnonymousUser();

  return (
    <Header>{isAnonymousUser ? <GoToPortalButton /> : <LogoutButton />}</Header>
  );
};
